module.exports = __webpack_public_path__ + "img/thumb-009-19.52a2ae01.png";